export default __webpack_public_path__ + "static/media/logo.b170a0f4.png";